import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalsComponent } from '../modals/modals.component';
import { RequestService } from '../services/request.service';
import { ActionsService } from '../services/actions.service';
import { FormControl } from '@angular/forms';
import { MatTableDataSource, MatPaginator, MatSort, MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { Location } from '@angular/common';
import { ProductService } from '../services/product.service';
import { Router } from '@angular/router';
import { MomentDateAdapter } from '@angular/material-moment-adapter';



export interface Request {
  id: string;
  reference_number: string;
  sort: string;
  batch: string;
  vintage: string;
  additional_notes: string;
  product_name: string;
  client_name: string;
  price_all: string;
  request_number: number;
}

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};



@Component({
  selector: 'app-request',
  templateUrl: './request.component.html',
  styleUrls: ['./request.component.css'],
  providers:[
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ]
})



export class RequestComponent implements OnInit {
  requests: any;
  add: boolean;
  edit: boolean;
  delete: boolean;
  columns: any;
  columnsToDisplay: any;
  displayedColumns: any;
  dataSource: any;
  selection: any;
  client_name: string;
  reference_number: string;
  fromDate: string;
  toDate: string;
  products:any;
  product_id:number;
  token:string = localStorage.getItem('token');
  
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  constructor(private requestService: RequestService,private productService:ProductService, public dialog: MatDialog, private actionService: ActionsService, private dateAdapter: DateAdapter<Date>,private _location: Location) {
    this.getRequest();
    this.getProducts();
    this.getActions();
    dateAdapter.setLocale('en-in');
    
  }

  ngOnInit() {
  }


  filterRequests(formData) {
    if (this.fromDate) {
      var formattedDate = new Date(this.fromDate).toLocaleDateString('en-GB');
      formData.fromDate = formattedDate;
    }

    if (this.toDate) {
      var formattedDate = new Date(this.toDate).toLocaleDateString('en-GB');
      formData.toDate = formattedDate;
    }

    this.requestService.filterRequests(formData).subscribe(data => {
      this.requests = data
      console.log(data);
      this.displayedColumns = ['reference_number', 'client_name', 'product_name', 'indicators', 'progress', 'notes', 'protocol', 'actions'];
      this.columnsToDisplay = this.displayedColumns.slice();
      this.dataSource = new MatTableDataSource<Request>(this.requests);
      this.selection = new SelectionModel<Request>(true, []);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
    });
  }

  getRequest() {
    this.requestService.getRequests().subscribe(data => {
      console.log(data);
      this.requests = data
      this.displayedColumns = ['reference_number', 'client_name', 'product_name', 'indicators', 'progress', 'notes', 'protocol', 'actions'];
      this.columnsToDisplay = this.displayedColumns.slice();
      this.dataSource = new MatTableDataSource<Request>(this.requests);
      this.selection = new SelectionModel<Request>(true, []);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
    });

    return this.requests;
  }

  getProducts() {
    this.productService.getAllProducts().subscribe(data => {
      this.products = Object.keys(data).map(i => data[i]);
    });
  }


  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }


  getActions() {
    this.actionService.moduleAction(1).subscribe(data => {
      if (data.watch_action == 1) {
        this.add = data.add_action;
        this.edit = data.edit_action;
        this.delete = data.delete_action;
      } else {
        this._location.back();
      }

    });
  }

  deleteModal(id, component): void {
    const dialogRef = this.dialog.open(ModalsComponent, {
      width: '250px',
      data: { id: id, component: component }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getRequest();
    });
  }

  copyRequest(id): void {
    const dialogRef = this.dialog.open(CopyRequest, {
      width: '250px',
      data: { id: id}
    });

  }


}


@Component({
  selector: 'copyRequest',
  templateUrl: 'copyRequest.html',
})
export class CopyRequest {

  constructor(public dialogRef: MatDialogRef<ModalsComponent>,
    private requestService: RequestService,private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: ModalsComponent) {
    console.log(data);
  }

  accept(id): void {
    this.dialogRef.close();
    this.requestService.copyRequest(id).subscribe(data => {
      
      if(data){
        this.router.navigate(['/requestEdit', data])
      }
      
    });
  }

  closeModal(): void {
    this.dialogRef.close();
  }

}